import { MarketTrendsAveragePriceResponse, MarketTrendsAvgPriceData, TREND_TYPES } from '../../types/marketTrends';
import { roundOff } from '../number';

export default (data: MarketTrendsAveragePriceResponse[] | null): MarketTrendsAvgPriceData => {
  const apData: MarketTrendsAvgPriceData = {
    OUTCODE: null,
    COUCIL_AREA: null,
    COUNTRY: null,
    ELECTORAL_AREA: null,
  };
  if (data) {
    TREND_TYPES.forEach((tt, i) => {
      const avgPrice = data[i];
      apData[tt] = {
        label: avgPrice?.label,
        change: avgPrice?.change == null ? null : roundOff((avgPrice?.change || 0) * 100, 1),
      };
    });
  }
  return apData;
};
